// frontend/app/i18n/dictionary.js
// Merges the legacy translation.json with per-feature shards. Static imports only
// (Metro/webpack need static requires).
import base from "./translation.json"
import header from "./shards/header.json"
import homeLessons from "./shards/home-lessons.json"
import collections from "./shards/collections.json"
import dashboard from "./shards/dashboard.json"
import messaging from "./shards/messaging.json"
import subscription from "./shards/subscription.json"
import journeys from "./shards/journeys.json"
import lboxL2 from "./shards/lbox-l2.json"
import lboxL4 from "./shards/lbox-l4.json"
import lboxL5 from "./shards/lbox-l5.json"
import lboxL6 from "./shards/lbox-l6.json"
import tests from "./shards/tests.json"
import lessonAuthoring from "./shards/lesson-authoring.json"
import lessonBlocks from "./shards/lesson-blocks.json"
import engagement from "./shards/engagement.json"
import jiraE2I18n from "./shards/jira-e2-i18n.json"
import jiraE5Students from "./shards/jira-e5-students.json"
import jiraE6Collections from "./shards/jira-e6-collections.json"
import jiraOctC from "./shards/jira-oct-c.json"
import jiraOctD from "./shards/jira-oct-d.json"
import jiraOctE from "./shards/jira-oct-e.json"
import homeWeekTime from "./shards/home-week-time.json"

export const SHARDS = {
  header,
  "home-lessons": homeLessons,
  collections,
  dashboard,
  messaging,
  subscription,
  journeys,
  "lbox-l2": lboxL2,
  "lbox-l4": lboxL4,
  "lbox-l5": lboxL5,
  "lbox-l6": lboxL6,
  tests,
  "lesson-authoring": lessonAuthoring,
  "lesson-blocks": lessonBlocks,
  engagement,
  "jira-e2-i18n": jiraE2I18n,
  "jira-e5-students": jiraE5Students,
  "jira-e6-collections": jiraE6Collections,
  "jira-oct-c": jiraOctC,
  "jira-oct-d": jiraOctD,
  "jira-oct-e": jiraOctE,
  "home-week-time": homeWeekTime,
}

const dictionary = Object.assign({}, base, ...Object.values(SHARDS))

export default dictionary
